/* eslint-disable react/prop-types */
import React from 'react';

export default function PartenaireBlock({ title, children }) {
  return (
    <div className="mt-4 !p-5 bg-bleu-hellio-1 border-solid border border-bleu-hellio-2 !rounded-lg text-gris-hellio">
      <h3 className="!mb-4 whitespace-pre-line font-medium text-base/6">
        {title}
      </h3>
      <div className="flex gap-2 flex-col">{children}</div>
    </div>
  );
}
